import React, { useState, useEffect } from "react";
import styles from "./styles.module.css";
import Modal from "../modal";
import { MdClose } from "react-icons/md";
import PropInput from "./propInput";
import ConditionInput from "./conditioninput";
import SelectElement from "./selectElement";

export default function SelectAction({
  action,
  onSave,
  onClose,
  actions,
  sources,
}) {
  const [schema, setSchema] = useState(null);
  const [_action, setAction] = useState(null);

  useEffect(() => {
    if (action) {
      setAction(action);
      console.log(action);
      const _schema = actions.find((x) => x.name === action.action);
      setSchema(_schema);
    } else {
      setSchema(null);
      setAction(null);
    }
  }, [action]);

  const handleChange = (a) => {
    console.log(a);
    setAction(a);
  };
  if (!_action || !schema) {
    return null;
  }
  return (
    <Modal onClose={onClose} open={true}>
      <div
        onMouseDown={(e) => e.stopPropagation()}
        className={styles.editAction}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className={styles.title}>{_action.name}</div>
          <MdClose onClick={onClose} className={styles.close} />
        </div>
        {schema.block && (
          <SelectElement
            action={_action}
            onChange={handleChange}
            block={schema.block}
          />
        )}
        {schema.props.map((p) => {
          return (
            <PropInput
              onChange={handleChange}
              action={_action}
              prop={p}
              key={p.name}
              sources={sources}
            />
          );
        })}
        {/* <ConditionInput
          onChange={handleChange}
          action={_action}
          sources={sources}
        /> */}
        <button onClick={() => onSave(_action)} className={styles.save}>
          SAVE
        </button>
      </div>
    </Modal>
  );
}
